import { ReportsRoute } from '../enums/reportsRoute'

export const getReportsFiltersStorageKey = (route: ReportsRoute | string, organizationId?: string) =>
  `reports-filters-${route}-${organizationId || ''}`
